interface CheckIconProps {
    color?: string;
    circleColor?: string;
    className?: string;
}

function CheckIcon({
    color = 'currentColor',
    circleColor = 'transparent',
    className = null,
}: CheckIconProps) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className={className}
        >
            <circle cx="20" cy="20" r="20" fill={circleColor} stroke="transparent" />
            <path
                d="M12 20.5L17.5 26L28 14.5"
                stroke={color}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default CheckIcon;
